import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/CustomerSupport/RaiseQuery.css';
import Input from '../../Shared/Input';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import SubmitQueryModal from '../../Shared/SubmitQueryModel';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { ALL_FAQ_CATEGORY_ENDPOINT, RAISE_QUERY_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { AES, enc } from 'crypto-js';
import { connect } from 'react-redux';
import { toast } from "react-toastify";
toast.configure()

class RaiseQuery extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            SelectCategory: '',
            categoryDropdown: false,
            text: '',
            textLimit: 0,
            hasOpenSuccess: false,
            errors: {},
            allCategories: [],
            apiDataAvailable: true,
            referenceNo: '',
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        ApiCall(
            'GET',
            baseURL + ALL_FAQ_CATEGORY_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    this.setState({ apiDataAvailable: false });
                }
                else {
                    console.log('I am 200!');
                    apiData.sort(
                        (a, b) =>
                            a.categoryName.trim()[0].charCodeAt(0) -
                            b.categoryName.trim()[0].charCodeAt(0),
                    );
                    this.setState({ allCategories: apiData })
                }
            } else {
                console.log('Something went wrong!');
            }
        });
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.SelectCategory) {
            formIsValid = false;
            errors["selectCategory"] = Message.validation.required;
            document.getElementsByName('SelectCategory')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SelectCategory')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.text) {
            formIsValid = false;
            errors["textquery"] = Message.validation.required;
            document.getElementsByName('textquery')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('textquery')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ categoryDropdown: false });
        }
    };
    toggleCategoryDropdown = () => {
        this.setState({ categoryDropdown: !this.state.categoryDropdown });
    };
    changeCategory = (event) => {
        const found = this.state.allCategories?.find((name) => {
            if (name.categoryId === this.state.allCategories[event].categoryId) {
                return name
            }
        })
        this.setState({ SelectCategory: found.categoryName });
        this.setState({ categoryDropdown: !this.state.categoryDropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                selectCategory: ''
            }
        });
        document.getElementsByName('SelectCategory')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleAllQueries = () => {
        this.props.history.push('/AllQueries')
    }
    onSubmitQuery = () => {
        if (this.handleValidation()) {
            ApiCall(
                "POST",
                baseURL + RAISE_QUERY_ENDPOINT,
                {
                    "faqCategory": this.state.SelectCategory,
                    "faqQuery": this.state.text,
                    "user": this.props.userProfileDataR?.userEmail
                },
                {
                    'Accept': "application/json",
                    "Content-Type": "application/json",
                }
            ).then((apiData) => {
                if (apiData.flag != -1) {
                    if (apiData.flag == 500) {
                        console.log("I am 500!");
                        toast('Something went wrong!', { position: toast.POSITION.TOP_CENTER, style: { color: "red" } });
                    } else {
                        document.documentElement.scrollTop = 0;
                        this.setState({
                            referenceNo: apiData?.caseIdReference,
                            hasOpenSuccess: true
                        });
                    }
                }
            });
        }
    }
    handleQureyTextMessage = (e) => {
        if (e.target.value?.length <= 1000) {
            this.setState({ textLimit: e.target.value?.length });
            this.setState({ text: e.target.value });
            this.setState({
                errors: {
                    ...this.state.errors,
                    textquery: ''
                }
            });
            document.getElementsByName('textquery')[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    onCloseModal = () => {
        this.setState({ hasOpenSuccess: false });
        this.props.history.push('/home', {});
    };
    render() {
        let drop = this.state.categoryDropdown ? <img src={arrowup} /> : <img src={downarrow} />
        return (
            <div class="csoutercolorraise">
                <MetaDecorator title={TitleDescription.raiseQueryPageTitle} description={TitleDescription.raiseQueryPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullraise">
                    <div id="csnobox111raise">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavcraise"> Raise Query</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="notificationmaincardraise">
                            <div class="toppartwhiteraise">
                                <div class="containsalldiv">
                                    <div class="firstwhiteraise">
                                        <div className="pass-wrapper" id="caad07raise" >
                                            <Input
                                                name="SelectCategory"
                                                readOnly class="input"
                                                value={this.state.SelectCategory}
                                                placeholder="Select Category"
                                                type="text" id="caad066raise"
                                            />
                                            <div className="Raiseerrorcategory">{this.state.errors["selectCategory"]}</div>
                                            <i id="caainput_imgAddProfileraise" onClick={this.toggleCategoryDropdown}>{drop}</i>
                                        </div>
                                        {this.state.categoryDropdown && (
                                            <div class="caaad08raise" >
                                                <div class="caadropdowncardraise" ref={this.container} >
                                                    {(this.state.apiDataAvailable &&
                                                        this.state.allCategories?.map((name, index) => {
                                                            return (
                                                                <table class='caaad09raise' key={index} onClick={() => this.changeCategory(index)} >
                                                                    <td class="caatt1raise" >
                                                                        <small id="caatt2raise" >{name?.categoryName} </small>
                                                                    </td>
                                                                </table>
                                                            );
                                                        }))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div class="secondwhiteraise">
                                        <div class="right03">
                                            <div class="textareamsg">
                                                <small class="lowter">Please describe the query </small>
                                            </div>
                                            <textarea name="textquery" class="inputlbor2raise" type="text" value={this.state.text}
                                                id="textMessage"
                                                onChange={this.handleQureyTextMessage}
                                            ></textarea>
                                            <div className="Raiseerror1">{this.state.errors["textquery"]}</div>
                                            <small class="inpsmallraise">{this.state.textLimit}/1000</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="okbttnplacardraise">
                                <div class="btttndivvraise">
                                    <Button class="bttplacardraise" onClick={this.onSubmitQuery}>
                                        <small id="placardokraise"> Submit</small>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
                <SubmitQueryModal hasOpen={this.state.hasOpenSuccess} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successRatingdivout">
                            <div class="RaiseSupportSmupdiv">
                                <small class="RaiseSupportSmupbold">Your query has been submitted successfully
                                    <small class="RaiseSupportSmupbold">with<b class='RaiseQueryBold'>Reference No. {this.state.referenceNo}.</b></small>
                                </small>

                            </div>
                            <div class="RaiseSupportDiv">
                                <small class="RaiseSupportSm">Our support team will respond on your registered email address.</small>
                            </div>
                        </div>
                    </div>
                </SubmitQueryModal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(RaiseQuery);